module.exports = __webpack_public_path__ + "static/media/activityBg.5a86c847.jpg";